// src/components/FinalCta.js
import React from 'react';
import { DASHBOARD_URL } from '../config/urls';
import './FinalCta.css';

const FinalCta = () => {
  return (
    <section className="final-cta">
      <h2>Your Goals Are Ready.<br />Are You Funded Yet?</h2>
      <p>
        Apply in minutes. Get approved fast.  
        Put the right loan to work where it matters.
      </p>
      <a href={DASHBOARD_URL} className="btn-primary">Get Started Today</a>
    </section>
  );
};

export default FinalCta;
